import { Link } from 'react-router-dom';
import { useTranslation } from '@mypoz/i18n';
import { Card, Icon } from '@mypoz/ui';

import { useFormat } from '@/lib/format.js';
import { buttonClass } from '@/lib/styles.js';

export interface WalletBalanceCardProps {
  balanceCents: number;
  currency: string;
  topUpHref: string;
}

export function WalletBalanceCard({ balanceCents, currency, topUpHref }: WalletBalanceCardProps) {
  const { t } = useTranslation();
  const fmt = useFormat();

  return (
    <Card className="relative overflow-hidden p-6 sm:p-7">
      <span className="absolute inset-x-0 top-0 h-1 bg-brand" />
      <span className="pointer-events-none absolute -right-10 -bottom-16 size-48 rounded-full bg-brand-soft/70" />

      <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <div className="mb-4 flex items-center gap-3">
            <span className="flex size-11 shrink-0 items-center justify-center rounded-md bg-brand-soft text-brand">
              <Icon name="account_balance_wallet" size={23} fill />
            </span>
            <p className="text-sm font-semibold tracking-[0.08em] text-muted uppercase">
              {t('dashboard.wallet.label')}
            </p>
          </div>

          <p className="text-4xl leading-none font-bold tracking-tight text-ink tabular-nums sm:text-5xl">
            {fmt.money(balanceCents, currency)}
          </p>
          <p className="mt-2 text-sm text-muted">{t('dashboard.wallet.spendable')}</p>
        </div>

        <Link to={topUpHref} className={buttonClass('primary', 'self-start sm:self-center')}>
          {t('dashboard.wallet.topUp')}
          <Icon name="arrow_forward" size={18} />
        </Link>
      </div>
    </Card>
  );
}
